import React from "react";
import { message, Form } from "antd";
import styled from "styled-components";
import { PlusOutlined } from "@ant-design/icons";

import Button from "components/buttons/Button";
import Input from "components/inputs/Input";
import Fetch from "components/Fetch";
import colors from "constants/palette";
import Select from "components/inputs/Select";

export default function Categories({ setData, oldData, handleCancel }) {
  const [form] = Form.useForm();

  const [loading, setLoading] = React.useState(false);

  const onSubmit = (data) => {
    console.log(data);
    const submitData = data;
    setLoading(true);
    if (!oldData) {
      // new :::::::::::::
      Fetch.post("/category", submitData, (res) => {
        console.log("new category response", res);
        if (res?.id) {
          message.success("با موفقیت اضافه شد");
          cleanForm(["title"]);
          setData((e) => [...e, res]);
        } else {
          if (res?.title) {
            message.error(res?.title?.[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
      });
    } else {
      // update :::::::::
      Fetch.put(`/category/${oldData.id}`, submitData, (res) => {
        console.log("new category response/UPDATE", res);
        if (res?.id) {
          message.success("با موفقیت آپدیت شد");

          setData((e) => {
            var newData = e;
            newData[e.findIndex((item) => item.id === res.id)] = res;
            console.log("newData", newData);
            return newData;
          });

          handleCancel();
          cleanForm(["title"]);
        } else {
          if (res?.errors?.title) {
            message.error(res?.errors.title[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
      });
    }
    setLoading(false);
  };

  function cleanForm(items) {
    form.resetFields(items);
  }
  if (oldData) {
    form.setFieldsValue(oldData);
  }

  return (
    <Form
      form={form}
      layout="vertical"
      style={{ direction: "rtl" }}
      name={oldData ? "update" : "new"}
      onFinish={onSubmit}
    >
      <Label>سر دسته :</Label>
      <Form.Item
        name="headCategory"
        rules={[
          {
            required: true,
            message: "لطفا سر دسته را انتخاب کنید!",
          },
        ]}
      >
        <Select
          style={{ width: "100%" }}
          borderradius="0"
          list={[
            "سگ",
            "گربه",
            "پرندگان",
            "خزندگان",
            "آبزیان",
            "حیوانات کوچک",
            "سایر",
          ]}
        />
      </Form.Item>
      <Label>زیر دسته :</Label>
      <Form.Item
        name="subCategory"
        rules={[
          {
            required: true,
            message: "لطفا زیر دسته را انتخاب کنید!",
          },
        ]}
      >
        <Select
          style={{ width: "100%" }}
          borderradius="0"
          list={subCategories}
        />
      </Form.Item>
      <Label>نام دسته بندی :</Label>
      <Form.Item
        name="title"
        rules={[
          {
            required: true,
            message: "لطفا نام دسته بندی را وارد کنید!",
          },
        ]}
      >
        <Input size="large" placeholder="" />
      </Form.Item>

      <Button
        loading={loading}
        htmlType="submit"
        style={{ width: "100%", marginTop: 16 }}
      >
        {oldData ? (
          "اصلاح"
        ) : (
          <span>
            <PlusOutlined style={{ marginLeft: 8 }} />
            اضافه کردن
          </span>
        )}
      </Button>
    </Form>
  );
}

const Label = styled.label`
  margin-bottom: 10px;
  display: block;
  color: ${colors.dark};
`;

const subCategories = [
  "غذا و تشویقی",
  "لوازم نگهداری",
  "بهداشت و سرگرمی",
  "مکمل غذایی",
  "کنسانتره",
  "لوازم سوارکاری",
  "آکواریوم و نگهداری",
];
